export const operatorRowData = [
    [':','Assigns a value to a variable.', 'var myVar: 6'],
    ['+','Returns the sum of the operands.', '3 + 4'],
    ['-','Returns the difference of the operands.', '5 - 2'],
    ['*','Returns the product of the operands.', '8 * 2.5'],
    ['/','Returns the quotient of the operands.', '15 / 2'],
    ['^','Returns the base to the exponent.', '9 ^ 2'],
    ['%','Returns the remainder of dividing the operators.', '0 % 2'],
    ['==','Returns 1 if the operands are equal.', '1 == 1'],
    ['!=','Returns 1 if the operands are not equal.', '0 != 1'],
    ['<','Returns 1 if the left operand is less than the right operand.', '5 < 7'],
    ['<=','Returns 1 if the left operand is less than or equal to the right operand.', '7 <= 7'],
    ['>','Returns 1 if the left operand is greater than the right operand.', '3 > 2'],
    ['>=','Returns 1 if the left operand is greater than or equal to the right operand.', '3 >= 2'],
    ['&&','Returns 1 if the left and right operand can both be translated to true', '1 && 2'],
    ['||','Returns 1 if either the left or right operand can both be translated to true', '0 || 2'],
    ['!','Returns 0 if the single operand can be translated to true, otherwise returns 1', '!1']
]